// extracted by mini-css-extract-plugin
module.exports = {"page":"LiveList_page__1JK2v","mainTable":"LiveList_mainTable__26rC3"};